<template>
  <div id="floatwindow" v-show="floatAd&&floatAd.show">
    <router-link to="/peasantsStrive/notice" v-if="floatAd&&floatAd.show">
      <img :src="floatAd.img" alt="">
    </router-link>
  </div>
</template>
<script>
import { countdate } from '@/datas/js/common.js'

export default {
  data () {
    return {
      floatAd: ''
    }
  },
  mounted () {
    let extconfig = this.$config && this.$config.extra_config ? JSON.parse(this.$config.extra_config) : {}

    // 获取飘窗内容
    const code = this.$point.code
    let floatAd = extconfig.config[code] && extconfig.config[code].floatAd ? extconfig.config[code].floatAd : extconfig.config.floatAd
    const newdate = this.$moment(new Date()).format('YYYY-MM-DD')
    const olddate = this.$moment(floatAd.date).format('YYYY-MM-DD')
    const dates = countdate(olddate, newdate)
    if (dates > floatAd.endDate) {
      // console.log('超过浮窗有效期')
      floatAd.show = false
    }
    if (floatAd) {
      this.floatAd = floatAd
    }
    // 飘窗
    if (!floatAd.show) return
    this.$nextTick(() => {
      var xin = true
      var yin = true
      var step = 1
      var delay = 10
      var $obj
      $(function () {
        $obj = $('#floatwindow')
        var time = window.setInterval(move, delay)
        $($obj).mouseover(function () {
          clearInterval(time)
        })
        $($obj).mouseout(function () {
          time = window.setInterval(move, delay)
        })
      })

      function move () {
        var left = $obj.offset().left
        var top = $obj.offset().top
        let L = 0 // 左边界和顶部边界
        let T = 0
        var R = $(window).width() - $obj.width() // 右边界
        var B = $(window).height() - $obj.height() // 下边界
        if (left < L) {
          xin = true // 水平向右移动
        }
        if (left > R) {
          xin = false
        }
        if (top < T) {
          yin = true
        }
        if (top > B) {
          yin = false
        }
        left = left + step * (xin === true ? 1 : -1)
        top = top + step * (yin === true ? 1 : -1)
        // 给div 元素重新定位
        $obj.offset({
          top: top,
          left: left
        })
      }
      $(function () {
        $('#a').click(function () {
          var b = $('#a').parent()
          $(b).remove()
        })
      })
    })
  }
}
</script>
<style lang="stylus" scoped>
#floatwindow
  position absolute
  top 1.6rem
  left 0
  width 4.5rem
  height 2.24rem
  border-radius 0.12rem
  background #fff
  overflow hidden
  z-index 100
  a
    display block
    width 100%
    height 100%
    img
      width 100%
      height 100%
      object-fit cover
</style>